import { Client } from './lib';
const config = {};
config.userAgent = `xcontact-omni teste`;
let pabx = "10.11.31.10";
config.hackWssInTransport = true;
config.account = {
    user: '1000',
    password: '1000',
    name: 'teste',
    uri: `1000@${pabx}`,
};
config.transport = {
    wsServers: `wss://${pabx}:8089/ws`,
    iceServers: [],
    userAgentString: `xcontact-omni teste`,
};
// config.media = {
//     input: {
//         id: tc.inputDevice, // default audio device
//         audioProcessing: false,
//         volume: 1.0,
//         muted: false,
//     },
//     output: {
//         id: tc.outputDevice, // default audio device
//         volume: 1.0,
//         muted: false,
//     },
// };
let client = new Client(config)

for (let i = 0; i < 500; i++) {
    start(client);
}


async function start(client) {
    //Essa porcaria mudou de register para connect
    try {
        await client.connect();
        console.log(client)
    } catch (e) {
        console.error(e)
    }

}